// 9fbef606107a605d69c0edbcd8029e5d
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledCarousel,
  StyledScroll,
  StyledGrid,
  StyledArrowRef,
} from '../styles/HorizontalCarousel.style';

const renderArrowButton = (showArrow, isVisible, onScrollClick, classNameVal) => {
  return isVisible && showArrow ? (
    <button onClick={onScrollClick} className={classNameVal} />
  ) : null;
};

const HorizontalCarousel = (props) => {
  const { children, isArrowVisible, itemRef, defaultTileWidth, slidesToScroll } = props;
  const scrollContainerRef = useRef(null);
  const scrollStartRef = useRef(null);
  const scrollEndRef = useRef(null);

  const [showRightArrow, setShowRightArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);

  const [isStartTileInView, setIsStartTileInView] = useState(true);
  const [isEndTileInView, setIsEndTileInView] = useState(false);

  useEffect(() => {
    const startElement = scrollStartRef.current;
    const endElement = scrollEndRef.current;
    const observerStart = new IntersectionObserver(([entry]) => {
      setIsStartTileInView(entry.isIntersecting);
    });

    const observerEnd = new IntersectionObserver(([entry]) => {
      setIsEndTileInView(entry.isIntersecting);
    });

    if (startElement) {
      observerStart.observe(startElement);
    }
    if (endElement) {
      observerEnd.observe(endElement);
    }

    return () => {
      if (startElement) {
        observerStart.unobserve(startElement);
      }
      if (endElement) {
        observerEnd.unobserve(endElement);
      }
    };
  }, [scrollStartRef, scrollEndRef]);

  useEffect(() => {
    setShowLeftArrow(!isStartTileInView);
    setShowRightArrow(!isEndTileInView);
  }, [isStartTileInView, isEndTileInView]);

  const onScrollNext = useCallback(() => {
    const oneTileWidth = itemRef?.current?.offsetWidth || defaultTileWidth;
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft += slidesToScroll * oneTileWidth;
    }
  }, [defaultTileWidth, itemRef, slidesToScroll]);

  const onScrollPrev = useCallback(() => {
    const oneTileWidth = itemRef?.current?.offsetWidth || defaultTileWidth;
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft -= oneTileWidth * slidesToScroll;
    }
  }, [defaultTileWidth, itemRef, slidesToScroll]);

  return (
    <StyledCarousel>
      <div className="carousel-arrows">
        {renderArrowButton(showLeftArrow, isArrowVisible, onScrollPrev, 'left-arrow')}
      </div>
      <StyledScroll ref={scrollContainerRef}>
        <StyledGrid className="carousel-content">
          <StyledArrowRef ref={scrollStartRef} />
          {children}
          <StyledArrowRef ref={scrollEndRef} rightEnd />
        </StyledGrid>
      </StyledScroll>
      <div className="carousel-arrows">
        {renderArrowButton(showRightArrow, isArrowVisible, onScrollNext, 'right-arrow')}
      </div>
    </StyledCarousel>
  );
};
HorizontalCarousel.propTypes = {
  children: PropTypes.node,
  isArrowVisible: PropTypes.bool,
  itemRef: PropTypes.node,
  slidesToScroll: PropTypes.number,
  defaultTileWidth: PropTypes.number,
};
HorizontalCarousel.defaultProps = {
  children: null,
  isArrowVisible: false,
  itemRef: null,
  slidesToScroll: 3,
  defaultTileWidth: 283,
};
export default HorizontalCarousel;
